import numberFormat from './numberFormat';
import { numberConstants } from '@/utils/constants';

/**
 * Currency value for 'en-US' locale plus the currency value
 * Example:
 * - 1000 Canadian Dollars: $100 CAD
 * - 1000 US Dollars: $100 USD
 * - 1000 Euro: E100 EUR
 * @param {Number} value
 * @param {String} currency
 * @param {Object} options
 */
export default function currencyFullFilter(
    value,
    currency,
    options = { format: numberConstants.FORMAT.DEFAULT }
) {
    const { format, ...optionsRest } = options;

    try {
        if (!currency) {
            return numberFormat(value, format);
        } else {
            let ret = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                ...optionsRest,
            }).format(value);
            let arrayRet = ret.split('$');

            if (arrayRet.length > 1) {
                return `$${arrayRet[1]} ${currency}`;
            } else {
                return `${ret} ${currency}`;
            }
        }
    } catch {
        return numberFormat(value);
    }
}
